import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bbdb4b9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5bbdb4b9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbdb4b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbdb4b9')) {
      api.createRecord('5bbdb4b9', component.options)
    } else {
      api.reload('5bbdb4b9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bbdb4b9&scoped=true", function () {
      api.rerender('5bbdb4b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/spu2/index.vue"
export default component.exports